module.exports = __webpack_public_path__ + "static/media/BR 2.ff1d1c86.mp3";